<template>
    <mu-card-header title="Name" subTitle="sub title" style="transform: translateX(-12px);">
        <mu-avatar icon="person" slot="avatar" />
    </mu-card-header>
</template>
<script>
export default {
    name: 'cardHeader'
}
</script>



// WEBPACK FOOTER //
// cardHeader.vue?1999b0f4